import { MuiTypography } from '@/features/shared/material-ui';
import clsx from 'clsx';
import React, { memo } from 'react';
import HorizontalButton from './components/HorizontalButton';
import { HorizontalButtonSetProps } from './HorizontalButtonSet.interfaces';
import useHorizontalButtonSetStyles from './HorizontalButtonSet.styles';

const HorizontalButtonSet = ({
  contentList = [],
  className: overrideClassName,
  title,
}: HorizontalButtonSetProps) => {
  const classes = useHorizontalButtonSetStyles();
  return (
    <div className={overrideClassName}>
      {title && (
        <MuiTypography variant="overline" component="h2" className={classes.title}>
          {title}
        </MuiTypography>
      )}
      <div className={clsx(classes.setButtonWrapper)}>
        {contentList.map((horizontalButton, index) => (
          <div className={classes.buttonWrapper} key={index}>
            <HorizontalButton {...horizontalButton} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(HorizontalButtonSet);
